import type { AllarmiPaginationDTO } from '@/models/dto/allarme/allarme-pagination-dto'
import type { AlarmsWithPagination } from '@/models/types/alarm/alarms-with-pagination'
import { mapToPagination, mapToPaginationDTO } from '../pagination-mapper'
import { mapToAllarmeSconosciutoDTO, mapToUnknownAlarm } from './unknows-alarm-mapper'

const mapToAlarms = (allarmiDTO: AllarmiPaginationDTO): AlarmsWithPagination => {
    return {
        alarms: allarmiDTO.allarme?.map(mapToUnknownAlarm) ?? undefined,
        pagination: mapToPagination(allarmiDTO.paginationData),
    }
}

const mapToAllarmiDTO = (alarms: AlarmsWithPagination): AllarmiPaginationDTO => {
    return {
        allarme: alarms.alarms?.map(mapToAllarmeSconosciutoDTO) ?? null,
        paginationData: mapToPaginationDTO(alarms.pagination),
    }
}

export { mapToAlarms, mapToAllarmiDTO }
